import React from 'react';
import Layout from '../layout';
import papan01 from '../../static/Konfest.png';
import SEO from '../components/SEO';
import './about.scss';

const About = () => {
  return (
    <Layout>
      <SEO title="About" path="/about" />
      <article className="about">
        <img src={papan01} className="user-avatar" alt="papan01" />
        <section className="about-context">
          <div>
            <h3>CSaju</h3>
            <p className="time">2021-01-01</p>
            <p>
            </p>
          </div>
        </section>
      </article>
    </Layout>
  );
};

export default About;
